import {
  Colors,
  Cross,
  Modal,
  ModalHr,
  Typography
} from '@giantleap/components-library'
import * as moment from 'moment'
import * as React from 'react'
import styles from './style.module.scss'
import { IProps, IState } from './types'

class InfoModal extends React.Component<IProps, IState> {
  getBirthDateDescription(date: number) {
    const momentDate = moment.unix(date)
    return `Birthdate: ${momentDate.format('MM/DD/YY')} (${moment().diff(
      momentDate,
      'years'
    )} years old)`
  }

  getCreateData(date: number) {
    return moment.unix(date).format('MMMM YYYY')
  }

  // getParent(parentId: string): any {
  //   // TODO create get parent from firebase method
  //   return {}
  // }

  render() {
    const {
      open,
      setActive,
      metaInfo: { added_by, added_date, name, birth_date, email }
    } = this.props
    // const { email, full_name } = this.getParent(added_by)
    // {
    //     added_by: child,
    //     added_date: child.created_at,
    //     name: child.first_name,
    //     birth_date: child.birth_date
    //   }
    return (
      <Modal
        active={open}
        setActive={setActive}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography
          type="title"
          size="big"
          className={styles.title}
          textAlign="left"
        >
          {name}
        </Typography>
        <Typography type="text" className={styles.text} textAlign="left">
          {this.getBirthDateDescription(birth_date)}
        </Typography>
        <ModalHr />
        <Typography type="headline" size="small" textAlign="left">
          Added by: {added_by}
        </Typography>
        <Typography type="headline" size="small" textAlign="left">
          Email: {email}
        </Typography>
        <Typography type="headline" size="small" textAlign="left">
          Added on: {this.getCreateData(added_date)}
        </Typography>
        {/* <Typography type="text" textAlign="left">Context: SOAR program</Typography> */}
      </Modal>
    )
  }
}

export default InfoModal



// WEBPACK FOOTER //
// ./src/components/InfoModal/index.tsx